import React from "react";
import '../index.css';
import Header from '../components/Header';
import Footer from "../components/Footer"; 
import homebanner from "../assets/home-banner.png"; 
import Pagetitlesection from "../components/pagetitlesection"; 

function PrivacyPolicy() {
  return (
    <>
      <Header />
      <div className="page-body-container">
        <Pagetitlesection title="Privacy Policy" backgroundImage={homebanner} />

  <div className="md:container mx-auto px-6 sm:px-6 py-10 flex flex-col items-center justify-center ">
 
 <section className="bg-white p-4 sm:p-8 rounded-lg shadow-md text-gray-800">
           <h2 className="md:text-2xl text-xl font-semibold mb-4 mt-0">
              We respect your data and privacy.
            </h2>

            <p className="mb-6 leading-relaxed text-justify">
              We do not sell your email address or any of your personal information to third parties. More information about our privacy practices is available at the <span className="font-medium text-blue-600 underline cursor-pointer">Giffypedia privacy policy</span>, donor privacy policy, and data retention guidelines.
            </p>

            <h2 className="md:text-2xl text-xl font-semibold mb-4 mt-8">How Do We Protect Your Data?</h2>
            <p className="mb-6 leading-relaxed text-justify">
              We strive to protect your information from unauthorized access, use, or disclosure. We use a variety of physical and technical measures, policies, and procedures (such as access control procedures, network firewalls, and physical security) designed to protect our systems and your personal information. Unfortunately, there’s no such thing as completely secure data transmission or storage, so we can’t guarantee that our security will not be breached (by technical measures or through violation of our policies and procedures).
            </p>

            <h2 className="md:text-2xl text-xl font-semibold mb-4 mt-8">Contact Us</h2>
            <p className="leading-relaxed text-justify">
              If you have questions or suggestions about this Privacy Policy or the information collected under this Privacy Policy, please email us at 
              <a href="mailto:giffypedia@gmail.com" className="text-blue-600 underline ml-1">giffypedia@gmail.com</a> or contact us directly.
            </p>
          </section>
 
</div>

        <Footer />
      </div>
    </>
  );
}

export default PrivacyPolicy;
